import { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getGroupStart,
  getAllGroupStart,
  resetGetGroupLoading,
} from "../../redux/exam-group/reducer";
import {
  selectLoadingGroupDetails,
  selectGroupDetails,
} from "../../redux/exam-group/selectors";

const useSingleExamGroupGet = ({ id }) => {
  const dispatch = useDispatch();
  const loadingGroup = useSelector(selectLoadingGroupDetails);
  const groupData = useSelector(selectGroupDetails);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const getGroupDetails = useCallback(() => {
    if (!id) return;
    dispatch(getGroupStart(id));
  }, [dispatch, id]);

  const resetGroupLoading = () => {
    dispatch(resetGetGroupLoading());
  };

  const fetchAllGroups = useCallback(() => {
    dispatch(getAllGroupStart());
  }, [dispatch]);

  useEffect(() => {
    getGroupDetails();
  }, [getGroupDetails, fetch]);

  return {
    loadingGroup,
    groupData,
    refetch,
    refetchGroups: fetchAllGroups,
    resetGroupLoading,
  };
};

export default useSingleExamGroupGet;
